import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { julian } from 'astronomia';
import CalDate from 'caldate';
import CalEvent from './CalEvent.js';
var Julian = /*#__PURE__*/function (_CalEvent) {
  _inherits(Julian, _CalEvent);
  var _super = _createSuper(Julian);
  function Julian() {
    _classCallCheck(this, Julian);
    return _super.apply(this, arguments);
  }
  _createClass(Julian, [{
    key: "inYear",
    value: function inYear(year) {
      if (this.opts.year && this.opts.year !== year) {
        return this;
      }
      var cal = new julian.CalendarJulian(year, this.opts.month, this.opts.day).toGregorian();
      var d = new CalDate(cal).setOffset(this.offset);
      this.dates.push(d);
      return this;
    }
  }]);
  return Julian;
}(CalEvent);
export { Julian as default };